<div class="actions-wrapper" *ngIf="!rwdService.isSmallDevice">
  <div class="avatar">
    <mat-icon>account_circle</mat-icon>
  </div>

  <button mat-button disableRipple="true" [matMenuTriggerFor]="userActionMenu">
    {{ currentUserName }}
    <mat-icon>arrow_drop_down</mat-icon>
  </button>
  <mat-menu #userActionMenu="matMenu">
    <button mat-menu-item disabled>
      <span>{{ 'account.edit' | loc }}</span>
    </button>
    <button mat-menu-item (click)="logOut()">
      <span>{{ 'account.logOut' | loc }}</span>
    </button>
  </mat-menu>
</div>
<div class="actions-wrapper mobile" *ngIf="rwdService.isSmallDevice">
  <div class="user font-16">
    <mat-icon class="avatar">account_circle</mat-icon>
    {{ currentUserName }}
  </div>
  <button mat-flat-button disabled>
    <span>{{ 'account.edit' | loc }}</span>
  </button>
  <button mat-flat-button (click)="logOut()">
    <span>{{ 'account.logOut' | loc }}</span>
  </button>
</div>
